import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/summit/stream")({
  beforeLoad: () => {
    throw redirect({ to: "/summit/day/$number", params: { number: 4 } });
  },
});
